const library: any = require('./core');

export interface IDelegateConstantVocabularyFunction {
  (
    scope: any,
    element: ng.IAugmentedJQuery,
    attrs: ng.IAttributes,
    event: ng.IAngularEvent,
    ...callParameters: any[]
  ): any;
}

export interface IDelegateConstant {
  uniqueComponent: string;
  vocabulary: {
    [fn: string]: IDelegateConstantVocabularyFunction;
  };
}

export interface IDelegateController {
  (delegateService: any, delegateConstant: IDelegateConstant): void;
}

interface IDelegateResponderLinkFn {
  (scope: any, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ctrl: any, transcludeFn: Function): void;
}

export interface IDelegateResponder {
  (delegateConstant: IDelegateConstant, linkFn: IDelegateResponderLinkFn): ng.IDirectiveLinkFn;
}

export default 'ui-ng-delegate';



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-delegate/src/main.ts